module.exports = __webpack_public_path__ + "img/second_step.7f3423de.png";